/*
 * Accordion rows in the block-driven mobile menu.
 *
 * MenuDrawer (global.js) attaches its slide-in submenu handler to EVERY
 * <summary> inside <header-drawer>. Left alone it would treat these accordions
 * as Dawn submenus and call trapFocus() on the open panel, so keyboard focus
 * could never leave it.
 *
 * A capture-phase listener on the <details> runs before the <summary>'s own
 * listeners, so stopping propagation there keeps MenuDrawer out of it.
 * stopPropagation does not cancel the default action, so <details> still
 * toggles natively — no open/close logic needed here.
 */
(function () {
  function guard(details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    details.addEventListener(
      'click',
      function (event) {
        if (summary.contains(event.target)) event.stopPropagation();
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('.mobile-menu__accordion').forEach(guard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
